/** Error codes returned by API v2 in ErrorDetail.errorCodes (see KoutravoApi Domain/Shared/Validators/Models/ErrorCode.cs). */
export const ApiV2ErrorCodes = {
	USER_EMAIL_NOT_EXISTS: "USER_EMAIL_NOT_EXISTS",
	USER_EXISTS_IN_ANOTHER_REFERENCE: "USER_EXISTS_IN_ANOTHER_REFERENCE"
};

/** True if the API v2 error response contains the given error code. */
export function hasApiV2ErrorCode(err: any, code: string): boolean {
	return Array.isArray(err?.error?.errorCodes) && err.error.errorCodes.includes(code);
}
